<template>
  <v-layout wrap>
    <v-flex xs12 xl8>
      <div :class="{ 'px-2': !isMobile }">
        <planner-tab-navigation
          v-if="!isMobile"
          :items="tabHeaders"
          :active.sync="active"
          :feedback-page="true"
          @tab-changed="setSelectedFavoritesTab($event)"
        />
        <div v-else>
          <v-tabs
            v-model="active"
            :centered="true"
            :grow="true"
            slider-color="#232C43"
          >
            <v-tab v-for="field in tabHeaders" :key="field.value">
              {{ field.title }}
            </v-tab>
          </v-tabs>
        </div>
        <!-- <div v-else class="mobile-text-header">
          Feedback Provided
        </div> -->
      </div>
      <div
        class="feedback-tab-content"
        :class="{ 'feedback-tab-shadow mx-2': !isMobile }"
      >
        <v-flex class="feedback-tab-content-name">
          <span>Client: {{ clientData.name }}</span>
        </v-flex>
        <client-feedback-info
          :feedback-type="getFeedbackType"
          :table-data="getTableData"
        />
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import ClientFeedbackInfo from './ClientFeedbackInfo.vue'
import PlannerTabNavigation from '../planner/PlannerTabNavigation.vue'
import { feedbackDataType } from '../../../utils/generalConsts'

export default {
  components: { ClientFeedbackInfo, PlannerTabNavigation },
  data() {
    return {
      active: 0,
      tabHeaders: [
        { value: 0, title: 'Feedback Required', icon: 'feedback' },
        {
          value: 1,
          title: 'Feedback Provided',
          svgIcon: 'hw-verified_feedback-24px',
          size: '20px'
        }
      ],
      feedbackDataType
    }
  },

  computed: {
    ...mapState('common', ['selectedFavoritesTab']),
    ...mapState('common', ['isMobile']),
    ...mapState('client', ['clientData']),
    ...mapGetters('client', ['feedbackNeededHomes', 'feedbackProvidedHomes']),

    getTableData() {
      return this.selectedFavoritesTab === 0
        ? this.feedbackNeededHomes
        : this.feedbackProvidedHomes
    },

    getFeedbackType() {
      return this.feedbackDataType[this.active]
    }
  },

  watch: {
    active() {
      this.setSelectedFavoritesTab(this.active)
    }
  },

  created() {
    if (this.selectedFavoritesTab > 1) {
      this.active = 0
      this.setSelectedFavoritesTab(this.active)
    } else {
      this.active = this.selectedFavoritesTab
    }
  },

  methods: {
    ...mapActions('common', ['setSelectedFavoritesTab'])
  }
}
</script>

<style lang="sass" scoped>
.feedback-tab-content
  border-radius: 0 0 1rem 1rem
  background: $hwayzWhite
  padding: 3rem
  min-height: 40vh
  &.feedback-tab-shadow
    -webkit-box-shadow: 0.2rem 0.2rem 0.5rem -0.2rem rgba(0, 0, 0, 0.3)
    -moz-box-shadow: 0.2rem 0.2rem 0.5rem -0.2rem rgba(0, 0, 0, 0.3)
    box-shadow: 0.2rem 0.2rem 0.5rem -0.2rem rgba(0, 0, 0, 0.3)
  @media only screen and (max-width: 700px)
    padding: 1rem
  @media only screen and (max-width: 450px)
    padding: 0
    border-radius: 0
    box-shadow: none
    height: 100vh
    margin: 0 !important
  &-name
    text-transform: capitalize
    padding: 16px 16px 0
    font-size: 15px
.mobile-text-header
  height: 48px
  line-height: 48px
  background: $hwayzWhite
  -webkit-box-shadow: 0.2rem 0.2rem 0.5rem -0.2rem rgba(0, 0, 0, 0.3)
  -moz-box-shadow: 0.2rem 0.2rem 0.5rem -0.2rem rgba(0, 0, 0, 0.3)
  box-shadow: 0.2rem 0.2rem 0.5rem -0.2rem rgba(0, 0, 0, 0.3)
  font-weight: 500
  font-size: 1.6rem
  text-transform: uppercase
  border-bottom: solid 2px $black
</style>
